// This file is generated via scripts/build-static-config.js
// Do not modify directly as changes will be overwritten in CI

export const CONFIGURATION = {
  country: 'ca',
  brand: 'th',
  env: 'prod',
  graphqlEnv: 'prod',
  graphqlGatewayEnv: '',
  sanityEnv: 'prod',
  platform: 'web',
  commitRef: 'bf16b453b8f1aa545bda66aeb45f65d1b00a63d0',
  releaseTimestamp: '1651512114',
  sanityDataset: '',
  sanityProjectId: 'czqk28jt',
  appFlowBuildId: '',
  adyen: {
    clientKey: '',
    environment: '',
    urlPrefix: '',
  },
  apiKeys: {
    amplitude: '65f663d03f6a8fe23adce8141aeabc57',
    branch: 'key_live_poB0w9VqXd6vhO4g0KJtFjcoDvmKyqoD',
    braze: 'cf6b4de2-8e5e-4539-ba74-329b5d58da43',
    bringg: '',
    googleMaps: 'AIzaSyBUrYV64BcH0tnLOTdKnEXfEbo6bvo7gwM',
    googleAnalytics: '',
    launchDarkly: '5cd475dba0ff54081d8bb4e0',
    launchDarklyMobileKey: '',
    logRocket: 'mj7uvx/ctg-prod',
    mParticle: 'a8efb7282cab184392072409ef0574a0',
    radar: '',
  },
  apple: {
    merchantId: 'merchant.com.timhortons.direct',
    paymentsNetworks: ['AmEx','MasterCard','Visa','Discover'],
    prepaidMerchantId: 'merchant.com.timhortons',
  },
  aws: {
    gqlApiUrl: 'https://use1-prod-th.rbictg.com/graphql',
    gqlGatewayApiUrl: 'https://use1-prod-th-gateway.rbictg.com/graphql',
    region: 'us-east-1',
    userPoolClientId: '3fmtnokmptq4l3q7pfham4o2fn',
    userPoolId: 'us-east-1_dWLdozxFz',
  },
  bringg: {
    region: '6',
  },
  datadog: {
    logs: {
      clientToken: 'pubef33725b766e012f924f42ac954f994a',
      dataCenter: '',
    },
    rum: {
      applicationId: '56023999-7952-45e4-8b63-5e6784f49d1a',
      clientToken: 'pubef33725b766e012f924f42ac954f994a',
      dataCenter: '',
    },
  },
  forter: {
    siteId: '2c89dca418ce',
  },
  google: {
    paymentsEnvironment: 'prod',
    paymentsGateway: 'chase',
    paymentsGatewayMerchantId: {
      ca: '594989',
      us: '597621',
    },
    paymentsNetworks: ['AMEX','MASTERCARD','VISA','DISCOVER','JCB'],
    prepaidPaymentsGateway: 'firstdata',
    prepaidPaymentsGatewayMerchantId: {
      ca: '311201840882',
      us: '335207214883',
    }
  },
  googleAdManager: {
    campaignId: '/22662485316/prod_timhortons/homepage',
  },
  googleTagManager: {
    containerId: 'GTM-WDB8JLW',
  },
  oneTrust: {
    cookieCompliance: {
      consentCategoryBranch: 'C0004',
      consentCategoryBraze: 'C0002',
      consentCategoryMParticle: 'C0001',
      globalConsentState: 'Opt-In',
      scriptUrl: 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js',
      scriptId: '66a89be1-05c8-450c-8532-a3b0a57f82dd',
    },
  },
  pypestream: {
    scriptUrl: 'https://web.pypestream.com/api-launcher.js',
    appId: '36b5aeff-b293-40d2-a2b7-649e5f1da536',
  },
  restaurants: {
    displayEnv: 'prod',
    validMobileOrderingEnvs: ['alpha','beta','live'],
  },
  urls: {
    braze: 'https://customer.iad-03.braze.com/api/v3',
    firstData: 'https://api.payeezy.com',
    firstDataTh: 'https://api.payeezy.com',
    webBaseUrl: '',
    thDigital: 'https://api.rbi.digital/payment',
  },
  tokenEx: {
    publicKey: 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA8gGPMwBRPuVyJReZGIkWH/+Bf5pnpDN1bSR2cLYLXVT8CaSnTw74qeboSnktgYCi1D9R3Bj2fYzTIwGGZb8KinLdxwbqZmHwrE9cFhCaHbG/E0PbqQGhXP2vbniZTT4M0i0Cbi7ES3Bw5zqNbIZZnX041QEpxLvIyWPKZCX+fBogNMhWfCF779aclChjHkwZMsufThVWE9xklWGxXiytx5aL4I5JPxq0I7cAkZGGs4aF/GxWwPaq7R3wPikJQ0YHnCMfcURzl2Hnw/inqyMy+JB6djTq2/BdzMAhWTh3cDWq9Xu+gEkb/QCd0n1yYIdKuDISlk/AfHdWe34IvzhVyQIDAQAB',
  },
  vrPayment: {
    braintreeTokenizationKey: '',
  },
  timeFormat: '',
  dateFormat: '',
  appStoreDeeplink: '',
};